import React from 'react';

/**
 * Plein écran de chargement pour l'éditeur de dossier.
 *
 * Volontairement minimal et autonome : pas de dépendance au layout
 * de l'éditeur, peut être rendu à n'importe quel stade du gate.
 */
const DossierLoadingView: React.FC = () => (
  <div className="flex justify-center items-center h-screen w-screen bg-mcdm-primary-100 dark:bg-mcdm-third-500">
    <div className="spinner-container">
      <div className="spinner" />
    </div>
  </div>
);

export default DossierLoadingView;
